// extracted by mini-css-extract-plugin
export var subtitle = "_ai-2";
export var title = "_ai-0";
export var titleNoWrap = "_ai-1";